export default __webpack_public_path__ + "static/media/trash.7af478f3.svg";